import { ReactElement } from 'react';
import { Controller } from 'react-hook-form';
import { Typography } from '@weareopenr/component-library';
import type { IPriceSchemeViewProps } from '../types';
import styles from './SchemeView.module.scss';
import { PriceSchemeSelectorBase } from 'src/components/PriceSchemeSelector/PriceSchemeSelectorBase/PriceSchemeSelectorBase';

const SchemeView = ({ control }: IPriceSchemeViewProps): ReactElement => {
  return (
    <section>
      <Typography weight="semi-bold" size="xxlarge" className={styles['subheader']}>
        Price Scheme
      </Typography>
      <Typography>Select the price scheme you would like to apply to this menu publication.</Typography>
      <div className={styles['price-scheme-selector-container']}>
        <Controller
          name="price-scheme"
          control={control}
          render={({ field }) => <PriceSchemeSelectorBase onChange={field.onChange} value={field.value} />}
        />
      </div>
    </section>
  );
};

export default SchemeView;
